import { PSF_KSF_CONVERSION_CONSTANT, ROOF_PRESSURE_ZONE, SLOPE_DEGREE, SLOPE_RISE, WALL_PRESSURE_ZONE } from "../constants/CALCULATOR_VALUES";
var isZone = function (selectedZoneValue, calcResult) { var result = calcResult.find(function (objZone) { return objZone.pressureZone == selectedZoneValue; }); return result; };
var filterWallResult = function (wallResult) { var allowZones = [11, 13]; var tempWallZones = wallResult.filter(function (wall) { return allowZones.includes(wall.pressureZone); }); return tempWallZones; };
var feetToMeters = function (feet) { var meters = Number(feet) * 0.3048; return meters.toFixed(2); };
var getSlopeEquivalent = function (isRiseRun, roofAreaSlope) { if (isRiseRun) {
    for (var i = 0; i < SLOPE_RISE.length; i++) {
        if (roofAreaSlope == SLOPE_RISE[i].value) {
            return "".concat(SLOPE_RISE[i].name, " in 12 (").concat(SLOPE_DEGREE[i].name, ")");
        }
    }
}
else {
    for (var i = 0; i < SLOPE_DEGREE.length; i++) {
        if (roofAreaSlope == SLOPE_DEGREE[i].value) {
            return "".concat(SLOPE_RISE[i].name, " in 12 (").concat(SLOPE_DEGREE[i].name, ")");
        }
    }
} };
var getWindUpliftByZone = function (selectedZoneValue, calcResult) { var result = isZone(selectedZoneValue, calcResult); if (result)
    return result.rating.toString();
else
    return '105'; };
var checkTallRoof = function (roofAreaHeight, ratio) {
    var roofResult = roofAreaHeight >= 90 || roofAreaHeight > 60 && ratio > 1;
    return roofResult;
};
var getZoneImage = function (slopeDegree, roofAreaHeight, roofAreaWidth, roofAreaLength) { var result = undefined; var height = Number(roofAreaHeight); var width = Number(roofAreaWidth); var length = Number(roofAreaLength); var minDimension = Math.min(width, length); var ratio = height / minDimension; if (slopeDegree <= 7 && (height <= 60 || height < 90 && ratio <= 1))
    result = 'Slope_LE_7_HasZone_1Prime'; if (slopeDegree <= 7 && checkTallRoof(height, ratio))
    result = 'Slope_LE_7_GE_90_Height_NoZone_1Prime'; if (slopeDegree > 7 && slopeDegree <= 27)
    result = 'Slope_GT_7_and_LE_27_Degrees'; if (slopeDegree > 27 && slopeDegree <= 45)
    result = 'Slope_GT_27_and_LE_45_Degrees'; if (slopeDegree > 45)
    return undefined; return result; };
var getWallZoneNameByValue = function (resultZoneValue) { var result = WALL_PRESSURE_ZONE.find(function (objZone) { return objZone.value === resultZoneValue; }); if (result)
    return result.name;
else
    return 'Unknown'; };
var getZoneNameByValue = function (resultZoneValue) { var result = ROOF_PRESSURE_ZONE.find(function (objZone) { return objZone.value === resultZoneValue; }); if (result)
    return result.name;
else
    return 'Unknown'; };
var mapRoofAreaRatingResult = function (calcResult) {
    var roofAreaRatingResult = [];
    calcResult.forEach(function (result) { var tempResult = { CopingRating: result.copingRating, FasciaRating: result.fasciaRating, PressureZoneId: result.pressureZone, WindPressure: result.pressure, WindUplift: result.rating }; roofAreaRatingResult.push(tempResult); });
    return roofAreaRatingResult;
};
var mapRoofAreaWallRatingResult = function (wallResult) {
    var roofAreaWallRatingResult = [];
    wallResult.forEach(function (result) { var tempResult = { PressureZoneId: result.pressureZone, WindPressure: result.windPressure, WindUplift: result.windRating }; roofAreaWallRatingResult.push(tempResult); });
    return roofAreaWallRatingResult;
};
var mapWindBorneData = function (value) { if (value === 0)
    return 2; if (value === 1)
    return 1; return 3; };
var mapZoneData = function (data) { var zoneArray = []; for (var index = 0; index < data.length; index++) {
    zoneArray.push({ name: getZoneNameByValue(data[index].pressureZone), value: data[index].pressureZone });
} return zoneArray; };
var psfToKPA = function (value) { return value * PSF_KSF_CONVERSION_CONSTANT; };
var returnFascia = function (zone, pressure) {
    var allowZones = [10, 11, 12, 13];
    var result = allowZones.find(function (objZone) { return objZone === zone; });
    if (result)
        return "".concat(pressure * 2);
    else
        return '';
};
var returnResistance = function (zone, pressure) {
    var allowZones = [2, 3, 10, 11, 12, 13];
    var result = allowZones.find(function (objZone) { return objZone === zone; });
    if (result)
        return "".concat(pressure * 2);
    else
        return '';
};
var sortCalc = function (a, b) {
    if (ROOF_PRESSURE_ZONE[a.pressureZone] < ROOF_PRESSURE_ZONE[b.pressureZone] || a.pressureZone == 4)
        return -1;
    if (ROOF_PRESSURE_ZONE[a.pressureZone] > ROOF_PRESSURE_ZONE[b.pressureZone])
        return 1;
    return 0;
};
export { isZone, feetToMeters, filterWallResult, getSlopeEquivalent, getWindUpliftByZone, getZoneImage, getWallZoneNameByValue, getZoneNameByValue, mapRoofAreaRatingResult, mapRoofAreaWallRatingResult, mapWindBorneData, mapZoneData, psfToKPA, returnFascia, returnResistance, sortCalc };
